const getSessionStorage = (key) => {
    return sessionStorage.getItem(key);
}

const setSessionStorage = (key, value) => {
    sessionStorage.setItem(key, value);
}

const removeSessionStorage = (key) => {
    sessionStorage.removeItem(key)
}

export { getSessionStorage, setSessionStorage, removeSessionStorage };


// WEBPACK FOOTER //
// ./app/utils/SessionStorageUtil.js